import { useCallback } from 'react';
import { useDialog } from '@gokrew/ui/context';

/**
 * Closes the dialog a content component was opened in. `ResponsiveDialog`
 * injects `dialogId` into the content element; without it (e.g. rendered
 * outside a dialog) every dialog closes, like `ConfirmationDialog` does.
 */
export const useCloseDialog = (dialogId?: string) => {
  const { closeDialog, closeAll } = useDialog();
  return useCallback(
    () => (dialogId ? closeDialog(dialogId) : closeAll()),
    [dialogId, closeDialog, closeAll]
  );
};
